import httpResource from "@/components/infrastructures/functions/http/httpResource";

export default class DeliveryService {

    // TODO 非推奨
    public static async complete(deliveryId: string) {
        return (await httpResource.post(`/v2/delivery/complete?deliveryId=${deliveryId}`)).data;
    }
}